import React, { type ReactNode } from "react";
import { Modal as AntdModal, type ModalProps, } from "antd";
import "./style.scss";

interface CustomModalProps extends Omit<ModalProps, "children"> {
    children: ReactNode;
    className?: string;
    wrapClassName?: string;
    rootClassName?: string;
    title?: ReactNode;
    description?: string;

}

const Modal: React.FC<CustomModalProps> = ({
    open,
    onOk,
    onCancel,
    title,
    description,
    children,
    footer = null,
    closable = false,
    closeIcon = null,
    width = 440,
    className,
    wrapClassName,
    rootClassName,
}) => {

    const customTitle = (
        <div className="modal-header-frame">
            <div className="modal-title">{title}</div>
            {description && <div className="modal-description text-sm text-gray-500">{description}</div>}
        </div>
    );

    return (
        <AntdModal
            className={className}
            wrapClassName={wrapClassName}
            rootClassName={rootClassName}
            width={width}
            title={customTitle}
            open={open}
            onOk={onOk}
            onCancel={onCancel}
            footer={footer}
            closable={closable}
            closeIcon={closeIcon}
        >
            {children}
        </AntdModal>
    );
};

export default Modal;
